import React from 'react';
import styled from 'styled-components';
import { config } from '@keytrade/functions';
import { Icon } from '@keytrade/components-icon';
import { Span } from '@keytrade/components-span';

const { list: colors } = config.colors;
const { getFont } = config.fonts;

const CheckBoxLabel = styled.label`
  padding: 0 20px 20px 20px;
  font-size: 16px;
  line-height: 24px;
  font-family: ${({ theme }) => getFont(theme, 'regular')};
  border-bottom: 1px solid ${colors.BlueLight};
`;

const CheckboxContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const CheckBoxInput = styled.input`
  appearance: none;
  background-color: ${colors.White};
  margin: 0;
`;

export type CheckboxData = {
  value: string;
  label: string;
  onChange: (event: any) => void;
  isSelected: boolean;
};

const CostumFilterCheckbox: React.FC<CheckboxData> = ({
  value,
  label,
  onChange,
  isSelected,
}) => {
  return (
    <CheckBoxLabel>
      <CheckBoxInput
        type='checkbox'
        id={`custom-checkbox-${label}`}
        name={label}
        value={value}
        checked={isSelected}
        onChange={(e) => onChange(e)}
      />
      <CheckboxContent>
        <Span weight={isSelected && 'bold'} color='BlueDark'>
          {label}
        </Span>
        {isSelected && <Icon icon='icn_check' size='20px' />}
      </CheckboxContent>
    </CheckBoxLabel>
  );
};

export default CostumFilterCheckbox;
